export default "__VITE_ASSET__CHzjFCQG__"